<template>
    <el-dialog class="el-dialogs" :title="title" width="400px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="100px">
            <el-form-item label="文件水印" prop="watermarkingContent">
                <el-input v-model.trim="searchForm.watermarkingContent" maxlength="20"
                          placeholder="请输入文件水印名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-switch
                        v-model="searchForm.status"
                        active-value="0"
                        inactive-value="1">
                </el-switch>
            </el-form-item>
            <el-form-item v-show="title == '编辑文件水印'" label="添加人" prop="createByName">
                <div>{{ searchForm.createName }}</div>
            </el-form-item>
            <el-form-item v-show="title == '编辑文件水印'" label="添加时间" prop="createTime">
                <div>{{ searchForm.createTime }}</div>
            </el-form-item>
            <el-form-item v-show="title == '编辑文件水印'" label="最后修改时间" prop="updateTime">
                <div>{{ searchForm.updateTime }}</div>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addWatermark",
    data() {
        return {
            title: '新增文件水印',
            visible: false,
            searchForm: {
                id: '',
                watermarkingContent: '',
                status: '1',
                createName: '',
                createTime: '',
                updateTime: '',
            },
            rules: {
                watermarkingContent: [
                    {required: true, message: '请填写文件水印名称', trigger: 'blur'}
                ]
            },
        }
    },

    methods: {
        init(row) {
            this.visible = true
            this.searchForm.id = ''
            if (row) {
                this.title = '编辑文件水印'
                this.$axios(this.api.allCommon.commonWatermarkGetById + row.id).then(data => {
                    if (data && data.status) {
                        Object.keys(this.searchForm).forEach(key=>{
                            this.searchForm[key] = data.data[key]
                        })
                    }
                })
            } else {
                this.title = '新增文件水印'
            }
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (!this.searchForm.id) {
                        this.$axios(this.api.allCommon.commonWatermarkSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('提交成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.allCommon.commonWatermarkUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>